import React from 'react';
import { useSelector } from 'react-redux';
import LineupMatchup from '../components/LineupMatchup';
import { getTabsState } from '../store/selectors/getLineupMatchup';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';

const LineupMatchupDataContainer = () => {
    const { tabsData } = useSelector(getTabsState) || [];

    return (
        <ErrorBoundaryWrapper componentName='Lineup'>
            <LineupMatchup
                tabsData={ tabsData }
            />
        </ErrorBoundaryWrapper>
    );
};
export default React.memo(LineupMatchupDataContainer);
